import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HostnameService } from '@services/hostname.service';
import {
  SSOConfigurationsResponse,
  SSOConfigurationUpdateRequest,
  SSOConfigurationUpdateResponse,
  SSOConfigurationCreateResponse,
  SSOConfigurationDeleteResponse
} from './sso-provider-settings.model';

@Injectable({ providedIn: 'root' })
export class SSOSettingsService {
  private httpClient = inject(HttpClient);
  private hostnameService = inject(HostnameService);
  private baseUrl = this.hostnameService.getOrigin();

  getConfigurations(teamRid: string): Observable<SSOConfigurationsResponse> {
    const rid = teamRid.replace('#', '');
    return this.httpClient.get<SSOConfigurationsResponse>(`${this.baseUrl}/api/v1/auth/sso/${rid}`);
  }

  createConfiguration(teamRid: string, payload: SSOConfigurationUpdateRequest): Observable<SSOConfigurationCreateResponse> {
    const rid = teamRid.replace('#', '');
    return this.httpClient.post<SSOConfigurationCreateResponse>(`${this.baseUrl}/api/v1/auth/sso/${rid}`, payload);
  }

  updateConfiguration(teamRid: string, payload: SSOConfigurationUpdateRequest): Observable<SSOConfigurationUpdateResponse> {
    const rid = teamRid.replace('#', '');
    return this.httpClient.patch<SSOConfigurationUpdateResponse>(`${this.baseUrl}/api/v1/auth/sso/${rid}`, payload);
  }

  deleteConfiguration(teamRid: string, configurationName: string): Observable<SSOConfigurationDeleteResponse> {
    const rid = teamRid.replace('#', '');
    return this.httpClient.delete<SSOConfigurationDeleteResponse>(`${this.baseUrl}/api/v1/auth/sso/${rid}`, {
      body: { configuration_name: configurationName }
    });
  }
}
